import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Sigma } from 'lucide-react';
import { useQualityDashboardStore } from '@/stores/qualityDashboard';

export function CoverageSummary() {
  const { coverage, loading, fetchCoverage } = useQualityDashboardStore();

  useEffect(() => {
    fetchCoverage();
  }, [fetchCoverage]);

  if (loading && coverage.length === 0) {
    return (
      <div className="text-sm text-slate-400 text-center py-8">
        <Loader2 size={14} className="animate-spin inline mr-2" />
        Loading coverage...
      </div>
    );
  }

  if (coverage.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <Sigma size={24} className="text-slate-300 mx-auto mb-2" />
        <p className="text-sm text-slate-500">No canonical entities yet.</p>
      </div>
    );
  }

  const totalCanonicals = coverage.reduce((s, r) => s + r.canonical_count, 0);
  const totalSources = coverage.reduce((s, r) => s + r.total_source_count, 0);
  const maxCount = Math.max(...coverage.map((r) => r.canonical_count));

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-semibold text-navy-900">Coverage by Entity Type</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            {totalCanonicals.toLocaleString()} canonicals · {totalSources.toLocaleString()} source concepts absorbed · {coverage.length} types
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1.5">
        {coverage.map((r) => {
          const widthPct = maxCount > 0 ? (r.canonical_count / maxCount) * 100 : 0;
          return (
            <Link
              key={r.entity_type}
              to={`/knowledge/estate/entities?entity_type=${encodeURIComponent(r.entity_type)}`}
              className="flex items-center gap-3 text-xs hover:bg-slate-50 rounded px-2 py-1 transition-colors"
            >
              <span className="w-44 truncate text-slate-700">{r.entity_type}</span>
              <div className="flex-1 bg-slate-100 rounded-full h-1.5 overflow-hidden">
                <div
                  className="h-full rounded-full bg-brand-teal transition-all"
                  style={{ width: `${widthPct}%` }}
                />
              </div>
              <span className="w-10 text-right font-semibold text-navy-900">
                {r.canonical_count}
              </span>
              <span className="w-16 text-right text-slate-500">
                conf {(r.avg_confidence * 100).toFixed(0)}%
              </span>
              <span className="w-16 text-right text-slate-500">
                ~{r.avg_source_count.toFixed(1)} src
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
